import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scene-container" }

import {ref,reactive,onMounted,onBeforeUnmount, onBeforeMount,watch} from 'vue'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'
import {ICard} from '@/types/baseInterFace'
import { getSceneTypes } from '@/service'
import {$enum, $config} from '@/global/index'
import {deviceSign} from '@/service/device/api'
import { generateRandomCode } from '@/utils/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const cardsList = ref<ICard[]>([])
const deviceParams = reactive({
  challenge:null,
  deviceId:null,
  signature:null,
})

watch(()=>[store.state.persistence.currentTenantId,store.state.persistence.userInfo.userId],
  ([newTenantId,newUserId])=>{
  if(Array.isArray(cardsList.value) && cardsList.value.length == 0 && newTenantId && newUserId){
    getPageData();
  }
},{deep:true})

async function getPageData(){
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "deviceId": deviceParams.deviceId,
    "challenge": deviceParams.challenge,
    "signature": deviceParams.signature
  }
  cardsList.value = []
  const {code, data, message} = await getSceneTypes(param);
  if(code == $enum.EnumResult.SUCCESS){
    if(Array.isArray(data) && data.length){
      let arr = []
      data.forEach(item => {
        arr.push({
          id: item.id,
          title: item?.courseTypeName && item?.courseTypeName != '其他'?item?.courseTypeName + '-' + item.sceneName:item.sceneName,
          description: item.typeDescription,
          userAvailable: item.userAvailable,
          pictureUrl: $config.FILE_ROOT_PATH + item.pictureUrl,
          isLocked: item.isLocked,
          courseTypeId: item.courseTypeId,
          permissionLevel: item?.permissionLevel,
          endTime:item?.endTime,
          qrcodeUrl:item?.qrcodeUrl,
          enableCloudStorage:item?.enableCloudStorage
        })
      });
      cardsList.value = arr
    }
  }
}

const handleClick = (card:ICard) => {
  if(card.isLocked) return
  const enableCloudStorage = card?.enableCloudStorage
  store.commit('persistence/setBreadcrumb',[
    {currentPage:1, path:'/scene',name:'主页',active:false,id:null,permissionLevel:card.permissionLevel},
    {currentPage:2, path:'/subScene',name:card.title, active:true, id:card.id,courseTypeId:card.courseTypeId}
  ]);
  store.commit('persistence/setEnableCloudStorage',enableCloudStorage)
}

const deviceSignFn = ()=>{
  const challenge = generateRandomCode(33)
  deviceSign({challenge}).then((res:any)=>{
    const {status,data} = res || {}
    if(status == 200){
      deviceParams.challenge = challenge
      deviceParams.deviceId = data?.device_id || null
      deviceParams.signature = data?.signature || null
    }
    // WebSocket 连接成功，重新调用 getPageData（带签名参数）
    if(store.state.persistence.currentTenantId && store.state.persistence.userInfo.userId){
      getPageData();
    }
  }).catch((err:any)=>{
    // WebSocket 连接失败（包括重连失败），不再调用 getPageData
    console.error('设备签名失败:', err)
  })
}

onMounted(()=>{
  if(store.state.persistence.currentTenantId && store.state.persistence.userInfo.userId){
    getPageData();
  }
})

onBeforeMount(()=>{
  deviceSignFn()
})



return (_ctx: any,_cache: any) => {
  const _component_vkm_carousel = _resolveComponent("vkm-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vkm_carousel, {
      cardsList: cardsList.value,
      useControls: true,
      currentPage: 1,
      isShowLock: true,
      isShowBuyButton: true,
      onOnClick: handleClick
    }, null, 8, ["cardsList"])
  ]))
}
}

})